if (!window.Eurus.loadedScript.has('product-cart.js')) {
  window.Eurus.loadedScript.add('product-cart.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCart', (
        wrappringVariantId,
        engravingVariantId,
      ) => ({
        loading: false,
        errorMessage: false,
        cartRecovery: false,
        mainHasError: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        insuranceVariantId: '',
        loadInsurance(id) {
          if (this.insuranceVariantId == '') {
            this.insuranceVariantId = id;
          }
        },
        _flattenCartErrors(errors) {
          if (typeof errors === 'string') return errors.trim();
          if (Array.isArray(errors)) {
            return errors.map(value => this._flattenCartErrors(value)).filter(Boolean).join(' ');
          }
          if (errors && typeof errors === 'object') {
            return Object.values(errors).map(value => this._flattenCartErrors(value)).filter(Boolean).join(' ');
          }
          return '';
        },
        _cartErrorMessage(response, fallback) {
          if (typeof response?.description === 'string' && response.description.trim()) return response.description.trim();
          if (typeof response?.message === 'string' && response.message.trim()) return response.message.trim();
          const structuredMessage = this._flattenCartErrors(response?.errors);
          return structuredMessage || fallback || window.Eurus.cart_error;
        },
        scrollToAtcBtn(btnId) {
          const originalAtcBtn = document.querySelector(`#${btnId}`);
          originalAtcBtn?.scrollIntoView({
            behavior: "smooth",
            block: 'center',
            inline: 'center'
          })
        },
        async addToCart(e, required, quickView, sticky) {
          const inlineCard = this.$refs.product_form?.classList.contains('card-product-inline-form') && this.$refs.product_form.closest('[data-inline-product-card]');
          const submittedVariant = this.$refs.product_form?.querySelector('input[name="id"]');
          const submittedVariantId = submittedVariant?.value;
          const inlineBlocked = () => inlineCard && (this.loading || submittedVariant?.disabled || !submittedVariantId || ['pending', 'error', 'unavailable'].includes(inlineCard.dataset.variantState));
          if (this.loading || this.cartRecovery || inlineBlocked()) { e.preventDefault(); return; }
          this.loading = true;
          this.errorMessage = false;
          this.cartRecovery = false;
          e.preventDefault();

          let ownsCartLock = false;
          let releaseCart;
          let added = false;
          let insuranceAdded = false;
          let postStarted = false;
          let changedProductIds;
          try {
            if (inlineCard && window.Eurus.productCardRefresh && !await window.Eurus.productCardRefresh.ensureFresh(inlineCard)) return;
            if (required) {
              var productInfo = this.$el.closest('.product-info');
              if(sticky){
                productInfo = document.querySelector('.product-info');
              }
              if (productInfo) {
                var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
                this.stopAction = false;
                let scrollStatus = false;
                
                propertiesInput.length && propertiesInput.forEach((input) => {
                  if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
                    input.classList.add("required-picker");
                    this.stopAction = true;
                    if(!scrollStatus){
                      input.parentElement.querySelector('.text-required').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                      });
                      scrollStatus = true;
                    }    
                  } else {
                    input.classList.remove("required-picker");
                  }                
                });              

                if (!this.stopAction) {
                  productInfo.querySelectorAll('.recipient_input').forEach(giftCardInput => {
                    if (!this.stopAction && giftCardInput.required) {
                      this.stopAction = Alpine.$data(giftCardInput.closest('[x-data]')).onChangeInput(giftCardInput);
                      if (this.stopAction) {
                        giftCardInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      }
                    }
                  });
                }
              }
              if (this.stopAction) {
                return true;
              }
            }
            releaseCart = await window.mwCart.acquire();
            ownsCartLock = true;
            // Another queued write may have invalidated inventory while we waited.
            if (inlineCard && window.Eurus.productCardRefresh && !await window.Eurus.productCardRefresh.ensureFresh(inlineCard)) return;
            if (inlineCard && (submittedVariant.disabled || submittedVariant.value !== submittedVariantId || ['pending', 'error', 'unavailable'].includes(inlineCard.dataset.variantState) || window.Eurus.productCardRefresh?.isFresh(inlineCard) === false)) {
              this.loading = false;
              return;
            }


            if (this.$refs.engraving_text && engravingVariantId) {
              if (this.$refs.engraving_text.value.trim()) {
                if (!this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.setAttribute('name', this.$refs.text_area_name.value);
              } else {
                if (this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.removeAttribute('name');
              }
            }

            var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
            let formData = new FormData(this.$refs.product_form);
            const productId = formData.get('product-id');
            var edt_element = productForm ? productForm.querySelector(`.hidden.cart-edt-properties-${productId}`) : null;
            if (edt_element) {
              edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
            }
            formData = new FormData(this.$refs.product_form);

            formData.append(
              'sections',
              Alpine.store('xCartHelper').getSectionsToRender().slice(0, 5).map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            const newFormData = new FormData();
            for (let [key, value] of formData.entries()) {
              if (value !== '') {
                newFormData.append(key, value);
              }
            }

            const match = document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)');
            const linkedProductList = newFormData.getAll('properties[_linked_product_id][]');
            const linkedProductListQty = newFormData.getAll('properties[_linked_product_id_qty][]');
            if (
              (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) || 
              (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) || 
              (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[2].trim() === '')) ||
              (linkedProductList.length > 0) ||
              (linkedProductListQty.length > 0)
            ) {
              const variantId = formData.get('id');
              const productTitle = productForm ? productForm.querySelector(`.product-variant-title-${formData.get('product-id')}-${variantId}`)?.textContent : null
              let additionalOptionData = [];
              if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) {
                additionalOptionData.push(
                  {
                    id: wrappringVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (linkedProductListQty.length > 0) {
                let qty = newFormData.get('quantity');
                linkedProductListQty.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: qty,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }
              if (linkedProductList.length > 0) {
                linkedProductList.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: 1,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }
              
              if (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) {
                additionalOptionData.push(
                  {
                    id: engravingVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[2].trim() === '')) {
                insuranceAdded = true;
                additionalOptionData.push(
                  {
                    id: this.insuranceVariantId,
                    quantity: 1
                  }
                );
              }
              if (additionalOptionData.length !== 0) {
                // Shopify's multi-item payload must include the primary item too.
                for (const [key, value] of Array.from(newFormData.entries())) {
                  if (['id', 'quantity', 'selling_plan'].includes(key) || key.startsWith('properties[')) {
                    newFormData.delete(key);
                    const itemKey = key.includes('[') ? key.replace('[', '][') : `${key}]`;
                    newFormData.append(`items[0][${itemKey}`, value);
                  }
                }
                additionalOptionData.forEach((item, index) => {
                  const base = `items[${index + 1}]`;

                  newFormData.append(`${base}[id]`, item.id);
                  newFormData.append(`${base}[quantity]`, item.quantity);

                  if (item.parent_id) {
                    newFormData.append(`${base}[parent_id]`, item.parent_id);
                  }

                  if (item.properties) {
                    Object.entries(item.properties).forEach(([key, value]) => {
                      newFormData.append(`${base}[properties][${key}]`, value);
                    })
                  }
                })
              }
            }

            postStarted = true;
            const result = await fetch(Eurus.cart_add_url, {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: newFormData
            });
            added = result.ok;
            const response = await result.json();
            if (!result.ok || Number(response.status) >= 400) {
              added = false;
              this.error_message_wrapper = response.errors && typeof response.errors === 'object' ? response.errors : {};
              if (Object.keys(this.error_message_wrapper).length) {
                document.querySelector('.recipient-error-message')?.classList.remove('hidden');
              }
              const error = new Error(this._cartErrorMessage(response, 'Unable to add this item to the cart.'));
              error.cartResponse = response;
              throw error;
            }
            added = true;
            const changedItems = response.items || [response];
            if (changedItems.length && changedItems.every(item => item.product_id)) {
              changedProductIds = [...new Set(changedItems.map(item => String(item.product_id)))];
            }
            const primaryItem = response.items
              ? response.items.find(item => String(item.variant_id || item.id) === String(formData.get('id')))
              : response;
            if (!primaryItem?.id) throw new Error('The cart response did not include the added item');
            if (insuranceAdded) document.cookie = `eurus_insurance=${this.insuranceVariantId}; path=/; SameSite=Lax`;
            if (this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
            this.error_message_wrapper = {};
            document.querySelector('.recipient-error-message')?.classList.add('hidden');

            // The purchase succeeded even if a later drawer/app update fails.
            document.dispatchEvent(new CustomEvent('eurus:product:added', { detail: { product: response } }));
            Alpine.store('xPopup')?.close();
            document.dispatchEvent(new CustomEvent('eurus:video-popup:close-popup'));
            const quickViewStore = Alpine.store('xQuickView');
            if (quickViewStore) {
              quickViewStore.show = false;
              quickViewStore.openPopupMobile = false;
            }
            const addAsBundle = quickView
              ? quickViewStore?.buttonQuickView?.dataset.addAsBundle
              : this.$refs.product_form.querySelector('[data-add-as-bundle="true"]');
            if (addAsBundle) {
              document.dispatchEvent(new CustomEvent('eurus:cart:add-as-bundle'));
            } else {
              await Alpine.store('xCartHelper').reRenderSections(response.sections);
              const notification = Alpine.store('xCartNoti');
              if (notification?.enable && primaryItem) notification.setItem(primaryItem);
              else Alpine.store('xMiniCart')?.openCart();
              const count = Number.parseInt(document.getElementById('cart-icon-bubble')?.textContent, 10);
              if (Number.isFinite(count)) Alpine.store('xCartHelper').currentItemCount = count;
              this.$el.closest('.choose-options')?.querySelector('.js-close-button')?.click();
              this.$el.closest('.js-product-container')?.querySelector('.js-close-button')?.click();
              document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
            }
          } catch (error) {
            if (added) {
              this.cartRecovery = true;
              // Navigate to the authoritative cart; never retry a successful POST.
              window.location.assign(window.Eurus.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);
            } else {
              this.errorMessage = true;
              const message = this._cartErrorMessage(error.cartResponse, this.$refs.error_message?.dataset.fallback || window.Eurus.cart_error);
              for (const ref of [this.$refs.error_message, this.$refs.error_message_mobile]) {
                if (ref && message) ref.textContent = message;
              }
              document.dispatchEvent(new CustomEvent('eurus:product:add-failed', { detail: { errorMessage: message } }));
              // Inventory failures may partially change the cart. Refresh without another POST.
              if (error.cartResponse && ownsCartLock) {
                try { await Alpine.store('xCartHelper').reRenderSections(); } catch (_) { /* Keep the purchase error visible. */ }
              }
            }
            console.error('Cart update:', error);
          } finally {
            if (ownsCartLock) releaseCart();
            this.loading = false;
            if (ownsCartLock) document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', {
              detail: { productIds: postStarted ? changedProductIds : [] }
            }));
          }
        }
      }))
    });
  });
}
